/**
 * Azərbaycan şəhərləri və Bakı rayonları siyahısı.
 * Həm PostJob (form), həm Jobs (filter) tərəfindən import edilir.
 */

export const CITIES = [
  'Bakı',
  'Abşeron',
  'Gəncə',
  'Sumqayıt',
  'Mingəçevir',
  'Naxçıvan',
  'Lənkəran',
  'Şirvan',
  'Şəki',
  'Zaqatala',
  'Ağcabədi',
  'Ağdam',
  'Ağdaş',
  'Ağsu',
  'Astara',
  'Balakən',
  'Bərdə',
  'Beyləqan',
  'Biləsuvar',
  'Cəlilabad',
  'Daşkəsən',
  'Füzuli',
  'Gədəbəy',
  'Goranboy',
  'Göyçay',
  'Göygöl',
  'Hacıqabul',
  'İmişli',
  'İsmayıllı',
  'Kürdəmir',
  'Lerik',
  'Masallı',
  'Neftçala',
  'Oğuz',
  'Qax',
  'Qazax',
  'Qəbələ',
  'Qobustan',
  'Quba',
  'Qusar',
  'Saatlı',
  'Sabirabad',
  'Salyan',
  'Samux',
  'Şamaxı',
  'Şəmkir',
  'Xaçmaz',
  'Xızı',
  'Yardımlı',
  'Zərdab',
]

export const BAKU_DISTRICTS = [
  'Binəqədi',
  'Həzi Aslanov',
  'Xətai',
  'Xəzər',
  'Nərimanov',
  'Nəsimi',
  'Nizami',
  'Pirallahı',
  'Qaradağ',
  'Sabail',
  'Sabunçu',
  'Suraxanı',
  'Yasamal',
]

/**
 * Şəhər + rayon birləşdirib "Bakı, Nəsimi" formatında qaytarır.
 * Əgər rayon yoxdursa, yalnız şəhəri qaytarır.
 */
export function formatCityDistrict(city, district) {
  if (!city) return ''
  if (district) return `${city}, ${district}`
  return city
}
